import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import "antd/dist/reset.css";
import Layout from "./components/Layout";
import LayoutCancellation from "./components/LayoutCancellation";

const App: React.FC = () => {
    return (
        <Router>
            <Routes>
                <Route path="/*" element={<MainLayout />} />
            </Routes>
        </Router>
    );
};

const MainLayout: React.FC = () => {
    const location = useLocation();

    let typeService = "Instalação"; // Valor padrão

    if (location.pathname.includes("/revisao")) {
        typeService = "Revisão";
    } else if (location.pathname.includes("/desinstalacao")) {
        typeService = "Desinstalação";
    } else if (location.pathname.includes("/layout-cancellation")) {
        return <LayoutCancellation />;
    }

    return <Layout typeService={typeService} />;
};

export default App;
